<template>
  <div>
    <textarea placeholder="Allergiat, muut lisätoiveet ja -huomiot" rows="7" class="mt-5 border-solid border rounded shadow p-3 border-gray-300 w-full" v-model="storeState.comments"></textarea>
  </div>
</template>

<script>
export default {
   name: 'info',

   props: ['store'],

   data () {
      return {
         storeState: this.store.state
      }
   }
}
</script>

<style scoped>
</style>
